module.exports = __webpack_public_path__ + "img/canada-cardiovascular-diseases-female.db721afa.png";